import {
  coreExtensionData,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';
import appPlugin from '@backstage/plugin-app';
import { CookieAuthRefreshProvider } from '@backstage/plugin-auth-react';
import { BreadcrumbDefinitionBlueprint } from '@ipen-portal/plugin-navigation-react';
import { Fragment } from 'react';

import { Root } from '../components/Root';
import { HeaderComponentsContext } from './HeaderComponentsContext';

export const AppLayout = appPlugin.getExtension('app/layout').override({
  factory: (_, { inputs }) => {
    const headerComponents = inputs.headerComponents.map(i => (
      <Fragment key={i.node.spec.id}>
        {i.get(coreExtensionData.reactElement)}
      </Fragment>
    ));
    const navigation = inputs.nav.get(coreExtensionData.reactElement);
    const children = inputs.content.get(coreExtensionData.reactElement);
    const breadcrumbDefinitions = inputs.breadcrumbDefinitions.map(item =>
      item.get(BreadcrumbDefinitionBlueprint.dataRefs.breadcrumbPartDefinition),
    );
    return [
      coreExtensionData.reactElement(
        <CookieAuthRefreshProvider pluginId="app">
          <HeaderComponentsContext.Provider value={headerComponents}>
            <Root
              breadcrumbDefinitions={breadcrumbDefinitions}
              headerComponents={headerComponents}
              navigation={navigation}
            >
              {children}
            </Root>
          </HeaderComponentsContext.Provider>
        </CookieAuthRefreshProvider>,
      ),
    ];
  },
  inputs: {
    breadcrumbDefinitions: createExtensionInput([
      BreadcrumbDefinitionBlueprint.dataRefs.breadcrumbPartDefinition,
    ]),
    headerComponents: createExtensionInput([coreExtensionData.reactElement]),
  },
});
